// @core/api/endpoints/task/suggest_task_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SuggestTaskScheduleRequest,
  SuggestTaskScheduleResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Suggest task schedule
 * Analyzes assignee availability, task estimated duration, priority, and due date to suggest optimal work time slots. Returns ranked suggestions considering working hours, existing commitments, and task deadlines. Useful for workforce planning and automated scheduling.
 */
export async function SuggestTaskSchedule(
  task_id: string,
  data: SuggestTaskScheduleRequest,
  options?: RequestOptions
): Promise<SuggestTaskScheduleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/suggest-schedule`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.post<SuggestTaskScheduleResponse>(requestPath, data, requestOptions);
}
